import { Paper } from '@material-ui/core'
import React from 'react'
import { wordDefinitions } from '../data'
import WordItem from './component'
const Words = () => {
    return (
        <Paper elevation={5} style={{ background: '#dfdfdf', padding: '20px', minWidth: '500px' }}>
            <h2>Word definitions</h2>
            In the grid below, check all the words whose definitions you are sure you know.
            {wordDefinitions.map((value, key) => (
                <WordItem id={key} key={key} question={value} />
            ))}
        </Paper>
    )
}


export default Words